import React from 'react';
import { Link } from 'react-scroll';

function Header() {
  return (
    <header id="hero">
      <video
        src={process.env.PUBLIC_URL + '/file_example_MP4_480_1_5MG.mp4'}
        loop
        autoPlay
        muted
        playsInline
      />
      <p className="hero-eyebrow">Renstia UG LTD</p>
      <h1>Finance software, engineering &amp; real estate</h1>
      <p className="hero-lead">
        We lend, we build software, and we help people find
        properties.
      </p>
      <div className="rowy hero-actions">
        <Link className="btny hero-btn" to="products" spy smooth duration={800} href="#products">
          Our products
        </Link>
        <Link className="btny hero-btn hero-btn-outline" to="contact" spy smooth duration={800} href="#contact">
          Get in touch
        </Link>
      </div>

      <div className="headerbg" />
    </header>
  );
}

export default Header;
